// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3pK7r","savePackageButton":"ClientWallet_savePackageButton__ZE2ef"};